import { gql } from '@apollo/client';
import type { ScanPromptInfo } from '../../scanResult';

/**
 * 包牌改流向扫描：逐包牌调用，后端一把完成全部门禁（仓型/TT/关包/回告/装车/TT 校验）+ 改包牌 nextStop，
 * 结果经 promptInfo 已按语言渲染（成功/拦截/需处理），前端直接展示。
 */
export const HANDLE_BAG_RESHIP_SCAN_EVENT = gql`
  mutation HandleBagReshipScanEvent(
    $bagNumber: String!
    $targetFlow: String!
    $lmCarrierCode: String
  ) {
    handleBagReshipScanEvent(
      bagNumber: $bagNumber
      targetFlow: $targetFlow
      lmCarrierCode: $lmCarrierCode
    ) {
      success
      messageKeyStr
      newSortingRule
      oldSortingRule
      affectedOrderCount
      message
      promptInfo {
        messageKey
        popupType
        title
        content
      }
    }
  }
`;

export interface BagReshipScanResultType {
  success: boolean;
  messageKeyStr?: string | null;
  newSortingRule?: string | null;
  oldSortingRule?: string | null;
  affectedOrderCount: number;
  message?: string | null;
  promptInfo?: ScanPromptInfo | null;
}

export interface HandleBagReshipScanEventResponse {
  handleBagReshipScanEvent: BagReshipScanResultType;
}

export interface HandleBagReshipScanEventVariables {
  bagNumber: string;
  targetFlow: string;
  lmCarrierCode?: string | null;
}
